export const businessProcessType = {
  borrower: 4,
  loan: 5,
  application: 2,
};
